// common/components/swipeableScreen/SwipeableScreen.tsx (веб — только стрелки)
import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import styles from "./SwipeableScreen.module.scss";

interface SwipeableScreenProps {
  children: React.ReactNode;
  hasPrev: boolean;
  hasNext: boolean;
  prevPath?: string;
  nextPath?: string;
}

export const SwipeableScreen: React.FC<SwipeableScreenProps> = ({
  children,
  hasPrev,
  hasNext,
  prevPath,
  nextPath,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      {hasPrev && (
        <button
          className={`${styles.arrow} ${styles.arrowLeft}`}
          onClick={() => prevPath && navigate(prevPath)}
        >
          <MdChevronLeft size={32} />
        </button>
      )}
      {children}
      {hasNext && (
        <button
          className={`${styles.arrow} ${styles.arrowRight}`}
          onClick={() => nextPath && navigate(nextPath)}
        >
          <MdChevronRight size={32} />
        </button>
      )}
    </div>
  );
};
